// extracted by mini-css-extract-plugin
module.exports = {"home":"Dashboard_home__2hXhK","active-button":"Dashboard_active-button__1Yb89"};